export default __webpack_public_path__ + "static/media/weaversgift.cb5d0dc5.png";